/* eslint-disable import/no-anonymous-default-export */
export default {
  partner: null,

  setPartner(partner) {
    this.partner = partner;
  },
};
